// extracted by mini-css-extract-plugin
export default {"card":"CommentCard_card__zSuhJ","pfp":"CommentCard_pfp__yrFj+","name":"CommentCard_name__1DGEO","loc":"CommentCard_loc__xpe1G"};